module.exports = __webpack_public_path__ + "img/history_fox.e620bd6c.svg";